export const USER_TYPES = ['submitter', 'website_owner'] as const;

export type UserType = (typeof USER_TYPES)[number];

type UserTypeCarrier = {
    userType?: string | null;
    info?: { userType?: string | null } | null;
} | null | undefined;

/** Missing or unknown values stay on the submitter dashboard. */
export function readUserType(user: UserTypeCarrier): UserType {
    const raw = user?.userType ?? user?.info?.userType;
    return raw === 'website_owner' ? 'website_owner' : 'submitter';
}
